import { Component } from '@angular/core';
import { Paginator } from '@app/classes/paginator';
import { XeroIntegrationJobRun } from '@app/models/payroll/company/xero-integration-job-run.model';
import { AuthService } from '@app/services/auth.service';
import { IndexView } from '@common/views/index/index.view';
import moment from 'moment';

@Component({
    selector: 'app-xero-errors-and-events-log-view',
    templateUrl: './xero-errors-and-events-log.template.html',
})
export class XeroErrorsAndEventsLogView extends IndexView {
    isLoading = true;
    paginator: Paginator;
    logs: XeroIntegrationJobRun[] = [];

    constructor(private auth: AuthService) {
        super();

        this.paginator = new Paginator(XeroIntegrationJobRun.param('company', this.auth.company?.id), {
            shouldAutoLoadData: true,
        });
        this.paginator.onLoading((isLoading) => (this.isLoading = isLoading));
    }

    formatDate(date: string): string {
        return moment(date).format('MMM D, YYYY [at] HH:mm:ss [EST]');
    }
}
